import React, { useEffect, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { Button, Col, Row } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import AxiosService from "../../../../utils/Config/ApiService";
import SupportLoader from "../../../../utils/Config/SupportLoader";
import { ApiRoutes } from "../../../../utils/Config/ApiRoutes";
import { getUserData } from "../../../../utils/Helpers";
import axios from "axios";
import mockResponse from './merchant-test.json';
const sanitizeCurrency = (value) => {
  if (!value) return "";
  let val = value.replace(/[^0-9.]/g, "");
  const parts = val.split(".");
  if (parts.length > 2) {
    val = parts[0] + "." + parts.slice(1).join("");
  }
  if (val.includes(".")) {
    const [integer, decimal] = val.split(".");
    val = `${integer}.${decimal.substring(0, 2)}`;
  }
  return val;
};

function Parameters() {
  const { search } = useLocation();
  const countryId = new URLSearchParams(search).get("countryId");
  const [currency, setCurrency] = useState(
    countryId == 18 ? "₦" : countryId == 236 ? "£" : "$"
  );
  const [productType, setProductType] = useState([]);
  const [merchant, setMerchant] = useState([]);
  const [shopifyCount, setShopifyCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const userData = getUserData();
  const history = useHistory();
  const { id } = useParams();
  const normalizedCountryId = Number(countryId);
  const isUsOrUkMerchant =
    normalizedCountryId === 1 || normalizedCountryId === 236;
  const [resellerId, setResellerId] = useState(null);


  const getMerchantParameters = async (value) => {
    setMerchant([]);
    try {
      // let res = await AxiosService.post(`/support/merchant/get-parameter`, {
      //   organizationId: id,
      //   countryId: 1,
      //   productType: value
      // })
      let res = await axios.post(
        `${process.env.REACT_APP_ROOT_URL}/apiv11/auth/getmerchantparams`,
        {
          organizationId: id,
          countryId: countryId,
          productType: value,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: `Basic ${process.env.REACT_APP_PHP_Auth_Token}`,
          },
        }
      );

      // Uncomment below line to use mock data for testing
      // const res = { data: mockResponse, status: 200 }; // Mock response for testing
      // console.log(res)

      if (res.status == 200) {
        let data = res.data.response;
        let defaultCount = data?.data
          ?.filter((e) => e?.selectedValue == true && e?.amount != "0.00")
          ?.map((e) => e.metaKey);
        setMerchant(data.data);
        setProductType(data.productTypeList);
        setShopifyCount(defaultCount);
        setResellerId(data?.resellerDetails || null);
        console.log("setResellerId", resellerId);
      }
    } catch (error) {
      console.log(error);
    }
  };



  const getNeededParams = (value) => {
    const data = merchant?.find((e) => e?.metaKey == value);
    return data;
  };

  const getNeededParamsByKeys = (values) => {
    if (!Array.isArray(values)) {
      return undefined;
    }
    return merchant?.find((e) =>
      values.some(
        (value) =>
          String(e?.metaKey || "").toUpperCase() ===
          String(value).toUpperCase()
      )
    );
  };

  // const handleCheckBox = (name, check) => {
  //   console.log(name, check);
  //   let merchantIndex = merchant?.findIndex((e) => e?.metaKey == name);
  //   let newArr = [...merchant];
  //   newArr[merchantIndex]["selectedValue"] = check;
  //   setMerchant(newArr);
  // };

  // New Add Checkout not in parameters
  const handleCheckBox = (name, check) => {
    let newArr = [...merchant];
    let merchantIndex = newArr.findIndex((e) => e?.metaKey === name);
    if (merchantIndex !== -1) {
      newArr[merchantIndex]["selectedValue"] = check;
    } else {
      newArr.push({
        metaKey: name,
        selectedValue: check,
      });
    }
    setMerchant(newArr);
  };

  const handleBarInput = (value) => {
    let merchantIndex = merchant?.findIndex((e) => e?.metaKey == "BARS");
    let newArr = [...merchant];
    newArr[merchantIndex]["BARS"] = value;
    setMerchant(newArr);
  };

  const handleCustomerTabNameInput = (value) => {
    let merchantIndex = merchant?.findIndex((e) => e?.metaKey == "CUSTOMER_TAB");
    let newArr = [...merchant];
    newArr[merchantIndex]["CUSTOMER_TAB_NAME"] = value;
    setMerchant(newArr);
  };

  const handleLogicalMerchantInput = (value) => {
    let merchantIndex = merchant?.findIndex((e) => e?.metaKey == "ITU");
    if (merchantIndex === -1) return;
    let newArr = [...merchant];
    const logicalIndex = newArr[merchantIndex]?.childList?.findIndex(
      (child) => child?.metaKey === "ITU_LOGICAL"
    );
    if (logicalIndex === -1) return;
    newArr[merchantIndex]["childList"][logicalIndex]["ITU_LOGICAL"] = value;
    newArr[merchantIndex]["childList"][logicalIndex]["LOGICAL_MERCHANT_ID"] =
      value;
    setMerchant(newArr);
  };




  const handleCellpayMerchantPricingTypeInput = (value) => {
    let merchantIndex = merchant?.findIndex((e) => e?.metaKey == "ITU");
    if (merchantIndex === -1) return;
    let newArr = [...merchant];
    const cellpayIndex = newArr[merchantIndex]?.childList?.findIndex(
      (child) => child?.metaKey === "ITU_CELLPAY"
    );
    if (cellpayIndex === -1) return;
    newArr[merchantIndex]["childList"][cellpayIndex][
      "CELLPAY_MERCHANT_PRICING_TYPE"
    ] = value;
    setMerchant(newArr);
  };


  const updateCellpayStoreField = (orgId, fieldName, value) => {
    let merchantIndex = merchant?.findIndex((e) => e?.metaKey === "ITU");
    if (merchantIndex === -1) return;
    let newArr = [...merchant];
    const cellpayIndex = newArr[merchantIndex]?.childList?.findIndex(
      (child) => child?.metaKey === "ITU_CELLPAY"
    );
    if (cellpayIndex === -1) return;
    const feeList = newArr[merchantIndex]["childList"]?.[cellpayIndex]?.["cellpayMerchantFee"];
    const feeIndex = feeList?.findIndex((f) => f?.organizationId === orgId);
    if (feeIndex !== -1 && feeList) {
      newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"][feeIndex][fieldName] = value;
      setMerchant(newArr);
    }
  };

  const updateCellpayStoreFieldForAll = (fieldName, value) => {
    let merchantIndex = merchant?.findIndex((e) => e?.metaKey === "ITU");
    if (merchantIndex === -1) return;
    let newArr = [...merchant];
    const cellpayIndex = newArr[merchantIndex]?.childList?.findIndex(
      (child) => child?.metaKey === "ITU_CELLPAY"
    );
    if (cellpayIndex === -1) return;
    const feeList =
      newArr[merchantIndex]["childList"]?.[cellpayIndex]?.["cellpayMerchantFee"];
    if (!Array.isArray(feeList) || feeList.length === 0) return;
    newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"] =
      feeList.map((store) => ({ ...store, [fieldName]: value }));
    setMerchant(newArr);
  };

  const updateCellpayProfitShares = (orgId, type, changedField, value) => {
    let merchantIndex = merchant?.findIndex((e) => e?.metaKey === "ITU");
    if (merchantIndex === -1) return;
    let newArr = [...merchant];
    const cellpayIndex = newArr[merchantIndex]?.childList?.findIndex(
      (child) => child?.metaKey === "ITU_CELLPAY"
    );
    if (cellpayIndex === -1) return;
    const feeList = newArr[merchantIndex]["childList"]?.[cellpayIndex]?.["cellpayMerchantFee"];
    const feeIndex = feeList?.findIndex((f) => f?.organizationId === orgId);

    if (feeIndex !== -1 && feeList) {
      let numericValue = value.replace(/\D/g, "");
      if (numericValue !== "") {
        numericValue = Math.min(100, Math.max(0, parseInt(numericValue, 10))).toString();
      }
      const otherValue = numericValue === "" ? "" : (100 - parseInt(numericValue, 10)).toString();

      if (type === "RECHARGE") {
        if (changedField === "MERCHANT") {
          newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"][feeIndex]["CELLPAY_MERCHANT_RECHARGE_PROFIT_SHARE"] = numericValue;
          newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"][feeIndex]["CELLPAY_SPACEPOINTE_RECHARGE_PROFIT_SHARE"] = otherValue;
        } else {
          newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"][feeIndex]["CELLPAY_SPACEPOINTE_RECHARGE_PROFIT_SHARE"] = numericValue;
          newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"][feeIndex]["CELLPAY_MERCHANT_RECHARGE_PROFIT_SHARE"] = otherValue;
        }
      } else if (type === "BILLPAY") {
        if (changedField === "MERCHANT") {
          newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"][feeIndex]["CELLPAY_MERCHANT_BILLPAY_PROFIT_SHARE"] = numericValue;
          newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"][feeIndex]["CELLPAY_SPACEPOINTE_BILLPAY_PROFIT_SHARE"] = otherValue;
        } else {
          newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"][feeIndex]["CELLPAY_SPACEPOINTE_BILLPAY_PROFIT_SHARE"] = numericValue;
          newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"][feeIndex]["CELLPAY_MERCHANT_BILLPAY_PROFIT_SHARE"] = otherValue;
        }
      }
      setMerchant(newArr);
    }
  };

  const updateCellpayProfitSharesForAll = (type, changedField, value) => {
    let merchantIndex = merchant?.findIndex((e) => e?.metaKey === "ITU");
    if (merchantIndex === -1) return;
    let newArr = [...merchant];
    const cellpayIndex = newArr[merchantIndex]?.childList?.findIndex(
      (child) => child?.metaKey === "ITU_CELLPAY"
    );
    if (cellpayIndex === -1) return;
    const feeList =
      newArr[merchantIndex]["childList"]?.[cellpayIndex]?.["cellpayMerchantFee"];
    if (!Array.isArray(feeList) || feeList.length === 0) return;

    let numericValue = String(value || "").replace(/\D/g, "");
    if (numericValue !== "") {
      numericValue = Math.min(100, Math.max(0, parseInt(numericValue, 10))).toString();
    }
    const otherValue =
      numericValue === "" ? "" : (100 - parseInt(numericValue, 10)).toString();

    newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"] =
      feeList.map((store) => {
        let updatedStore = { ...store };
        if (type === "RECHARGE") {
          if (changedField === "MERCHANT") {
            updatedStore["CELLPAY_MERCHANT_RECHARGE_PROFIT_SHARE"] = numericValue;
            updatedStore["CELLPAY_SPACEPOINTE_RECHARGE_PROFIT_SHARE"] = otherValue;
          } else {
            updatedStore["CELLPAY_SPACEPOINTE_RECHARGE_PROFIT_SHARE"] = numericValue;
            updatedStore["CELLPAY_MERCHANT_RECHARGE_PROFIT_SHARE"] = otherValue;
          }
        } else if (type === "BILLPAY") {
          if (changedField === "MERCHANT") {
            updatedStore["CELLPAY_MERCHANT_BILLPAY_PROFIT_SHARE"] = numericValue;
            updatedStore["CELLPAY_SPACEPOINTE_BILLPAY_PROFIT_SHARE"] = otherValue;
          } else {
            updatedStore["CELLPAY_SPACEPOINTE_BILLPAY_PROFIT_SHARE"] = numericValue;
            updatedStore["CELLPAY_MERCHANT_BILLPAY_PROFIT_SHARE"] = otherValue;
          }
        }
        return updatedStore;
      });

    setMerchant(newArr);
  };

  const isValidCellpayFee = (value, maxLimit) => {
    if (value === "" || value === null || value === undefined) return false;
    const numericValue = Number(value);
    return !Number.isNaN(numericValue) && numericValue > 0 && numericValue <= maxLimit;
  };

  const getCellpayBillpayFeeError = (value, maxLimit) => {
    if (value === "" || value === null || value === undefined) {
      return "Bill Pay Fee must be greater than 0.";
    }

    const numericValue = Number(value);

    if (Number.isNaN(numericValue) || numericValue <= 0) {
      return "Bill Pay Fee must be greater than 0.";
    }

    if (numericValue > maxLimit) {
      return `The limit of ${maxLimit} has been exceeded.`;
    }

    return "";
  };

  const getCellpayProfitShareFieldError = (type, value) => {
    if (value === "" || value === null || value === undefined) {
      return type === "RECHARGE"
        ? "Invalid CellPay Recharge Profit Share."
        : "Merchant % and Spacepointe % are required.";
    }

    return "";
  };

  const getCellpayProfitShareError = (type, merchantValue, spacepointeValue) => {
    if (
      merchantValue === "" ||
      merchantValue === null ||
      merchantValue === undefined ||
      spacepointeValue === "" ||
      spacepointeValue === null ||
      spacepointeValue === undefined
    ) {
      return type === "RECHARGE"
        ? "Invalid CellPay Recharge Profit Share."
        : "Merchant % and Spacepointe % are required.";
    }

    const merchantNumeric = Number(merchantValue);
    const spacepointeNumeric = Number(spacepointeValue);

    if (Number.isNaN(merchantNumeric) || Number.isNaN(spacepointeNumeric)) {
      if (type === "RECHARGE") {
        return "Invalid CellPay Recharge Profit Share.";
      }
      return "Merchant % and Spacepointe % must be valid numbers.";
    }

    if (
      merchantNumeric < 0 ||
      merchantNumeric > 100 ||
      spacepointeNumeric < 0 ||
      spacepointeNumeric > 100
    ) {
      if (type === "RECHARGE") {
        return "Invalid CellPay Recharge Profit Share.";
      }
      return "Merchant % and Spacepointe % must be between 0 and 100.";
    }

    if (merchantNumeric + spacepointeNumeric !== 100) {
      if (type === "RECHARGE") {
        return "Invalid CellPay Recharge Profit Share.";
      }
      return "Merchant % and Spacepointe % must total 100.";
    }

    return "";
  };

  const handleLevelOneRadio = (name, level) => {
    let merchantIndex = merchant?.findIndex((e) => e?.metaKey == name);
    if (merchantIndex === -1) return;
    let newArr = [...merchant];
    // Support ITU having three options: Logical(1), Others(2), Cellpay(3)
    if (name === "ITU") {
      const childList = newArr[merchantIndex]?.childList;
      if (!Array.isArray(childList)) return;

      const setSelectedByKey = (metaKey, selected) => {
        const idx = childList.findIndex((c) => c?.metaKey === metaKey);
        if (idx !== -1) childList[idx]["selectedValue"] = selected;
        return idx;
      };

      setSelectedByKey("ITU_LOGICAL", level === 1);
      setSelectedByKey("ITU_OTHERS", level === 2);
      const cellpayIndex = setSelectedByKey("ITU_CELLPAY", level === 3);

      if (level === 3 && cellpayIndex !== -1) {
        if (!childList[cellpayIndex]["childList"] || childList[cellpayIndex]["childList"].length === 0) {
          childList[cellpayIndex]["childList"] = [
            { metaKey: "CELLPAY_RECHARGE", parameterName: "Recharge", selectedValue: false },
            { metaKey: "CELLPAY_BILLPAYMENT", parameterName: "Bill Payment", selectedValue: false }
          ];
        }
      }
    } else {
      if (level === 1) {
        newArr[merchantIndex]["childList"][0]["selectedValue"] = true;
        newArr[merchantIndex]["childList"][1]["selectedValue"] = false;
      } else {
        newArr[merchantIndex]["childList"][0]["selectedValue"] = false;
        newArr[merchantIndex]["childList"][1]["selectedValue"] = true;
      }
    }
    setMerchant(newArr);
  };

  // Handle checkbox state for Cellpay sub-options
  const handleCellpayCheckbox = (name, check) => {
    let merchantIndex = merchant?.findIndex((e) => e?.metaKey == "ITU");
    if (merchantIndex === -1) return;
    let newArr = [...merchant];
    const cellpayIndex = newArr[merchantIndex]?.childList?.findIndex((c) => c?.metaKey === "ITU_CELLPAY");
    if (cellpayIndex === -1) return;
    const cellpay = newArr[merchantIndex]?.childList?.[cellpayIndex];
    if (!cellpay) return;

    // Initialize childList if it doesn't exist or is empty
    if (!cellpay.childList || cellpay.childList.length === 0) {
      newArr[merchantIndex]["childList"][cellpayIndex]["childList"] = [
        { metaKey: "CELLPAY_RECHARGE", parameterName: "Recharge", selectedValue: false },
        { metaKey: "CELLPAY_BILLPAYMENT", parameterName: "Bill Payment", selectedValue: false }
      ];
    }

    // Find child by metaKey and update selectedValue
    const subIdx = newArr[merchantIndex]["childList"][cellpayIndex]["childList"].findIndex((c) => c?.metaKey === name);
    if (subIdx === -1) return;
    newArr[merchantIndex]["childList"][cellpayIndex]["childList"][subIdx]["selectedValue"] = check;

    // Clear the fee values if unchecked
    if (!check && newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"]) {
      newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"] = newArr[merchantIndex]["childList"][cellpayIndex]["cellpayMerchantFee"].map(store => {
        let updatedStore = { ...store };
        if (name === "CELLPAY_RECHARGE") {
          updatedStore.CELLPAY_MERCHANT_RECHARGE_FEE_LIMIT = "0";
          updatedStore.CELLPAY_MERCHANT_RECHARGE_PROFIT_SHARE = "0";
          updatedStore.CELLPAY_SPACEPOINTE_RECHARGE_PROFIT_SHARE = "0";
        } else if (name === "CELLPAY_BILLPAYMENT") {
          updatedStore.CELLPAY_MERCHANT_BILLPAY_FEE_LIMIT = "0";
          updatedStore.CELLPAY_MERCHANT_BILLPAY_PROFIT_SHARE = "0";
          updatedStore.CELLPAY_SPACEPOINTE_BILLPAY_PROFIT_SHARE = "0";
        }
        return updatedStore;
      });
    }

    setMerchant(newArr);
  };

  const handleLevelTwoRadio = (value) => {
    let merchantIndex = merchant?.findIndex(
      (e) => e?.metaKey == "MERCHANT_PROCESSING"
    );
    let newArr = [...merchant];
    if (value === 1) {
      newArr[merchantIndex]["childList"][1]["chargeTypeList"][0][
        "selectedValue"
      ] = true;
      newArr[merchantIndex]["childList"][1]["chargeTypeList"][1][
        "selectedValue"
      ] = false;
    } else {
      newArr[merchantIndex]["childList"][1]["chargeTypeList"][0][
        "selectedValue"
      ] = false;
      newArr[merchantIndex]["childList"][1]["chargeTypeList"][1][
        "selectedValue"
      ] = true;
    }
    setMerchant(newArr);
  };

  const handleLevelThreeInput = (name, value, level) => {
    let merchantIndex = merchant?.findIndex(
      (e) => e?.metaKey == "MERCHANT_PROCESSING"
    );
    let newArr = [...merchant];
    if (level === 1) {
      newArr[merchantIndex]["childList"][1]["chargeTypeList"][0][name] = value;
    } else {
      newArr[merchantIndex]["childList"][1]["chargeTypeList"][1][name] = value;
    }
    setMerchant(newArr);
  };


  const handleSubmit = () => {
    let errorCount = 0;
    let extraForShopify;
    let totalPriceParameter;

    let parameter = merchant.map((e) => ({
      metaKey: e.metaKey,
      metaValue: e.selectedValue,
    }));
    totalPriceParameter = merchant
      .filter((e) => e.selectedValue == true && e.amount != "0.00")
      ?.map((e) => e.metaKey);
    extraForShopify = merchant
      .filter((e) => e.amount != "0.00")
      ?.map((e) => e.metaKey);

    const indexFinder = (name, data) => {
      let index = data?.findIndex((e) => e?.metaKey == name);
      return index == -1 ? false : index;
    };

    if (indexFinder("BARS", parameter)) {
      if (merchant[indexFinder("BARS", merchant)]?.selectedValue == true) {
        let txtValue =
          merchant[indexFinder("BARS", merchant)][
          merchant[indexFinder("BARS", merchant)]["metaKey"]
          ];
        let dummy = [...parameter];
        if (txtValue != "" && txtValue != undefined) {
          dummy[indexFinder("BARS", parameter)]["txtValue"] = txtValue;
        } else {
          alert("Needed Pre Auth Amount");
          errorCount++;
        }
        parameter = dummy;
      }
    }

    if (indexFinder("CUSTOMER_TAB", parameter)) {
      if (merchant[indexFinder("CUSTOMER_TAB", merchant)]?.selectedValue == true) {
        // let txtValue = merchant[indexFinder("CUSTOMER_TAB", merchant)]?.CUSTOMER_TAB_NAME;
        // parameter.push({
        //   metaKey: "CUSTOMER_TAB_NAME",
        //   metaValue: txtValue ?? "",
        // });
        // if (txtValue != "" && txtValue != undefined) {
        //   parameter.push({
        //     metaKey: "CUSTOMER_TAB_NAME",
        //     metaValue: txtValue,
        //   });
        // } else {
        //   alert("Needed Customer Tab Name");
        //   errorCount++;
        // }
      }
    }

    if (indexFinder("TIP", parameter)) {
      if (merchant[indexFinder("TIP", merchant)]?.selectedValue == true) {
        let tip = merchant[indexFinder("TIP", merchant)]?.childList?.map(
          (e) => ({ metaKey: e.metaKey, metaValue: e.selectedValue })
        );
        parameter.push(tip[0]);
        parameter.push(tip[1]);
      }
    }

    if (indexFinder("DUALPRICING", parameter)) {
      if (
        merchant[indexFinder("DUALPRICING", merchant)]?.selectedValue == true
      ) {
        let radios = merchant[
          indexFinder("DUALPRICING", merchant)
        ]?.childList?.map((e) => ({
          metaKey: e.metaKey,
          metaValue: e.selectedValue,
        }));
        parameter.push(radios[0]);
        parameter.push(radios[1]);
      }
    }

    const ituParameterIndex = indexFinder("ITU", parameter);
    const ituMerchantIndex = indexFinder("ITU", merchant);
    if (ituParameterIndex !== false && ituMerchantIndex !== false) {
      if (merchant[ituMerchantIndex]?.selectedValue == true) {
        const ituMerchant = merchant[ituMerchantIndex];
        const ituChildren = Array.isArray(ituMerchant?.childList)
          ? ituMerchant.childList
          : [];

        const ituChildParams = ituChildren
          .filter((c) =>
            ["ITU_LOGICAL", "ITU_OTHERS", "ITU_CELLPAY"].includes(c?.metaKey)
          )
          .map((c) => ({ metaKey: c.metaKey, metaValue: c.selectedValue }));
        parameter.push(...ituChildParams);

        const logicalChild = ituChildren.find((c) => c?.metaKey === "ITU_LOGICAL");
        if (logicalChild?.selectedValue === true) {
          const logicalMerchantId =
            logicalChild?.LOGICAL_MERCHANT_ID || logicalChild?.ITU_LOGICAL;

          if (logicalMerchantId != "" && logicalMerchantId != undefined) {
            parameter.push({
              metaKey: "LOGICAL_MERCHANT_ID",
              metaValue: logicalMerchantId,
            });

            let dummy = [...parameter];
            const ituLogicalParamIndex = indexFinder("ITU_LOGICAL", dummy);
            if (ituLogicalParamIndex !== false) {
              dummy[ituLogicalParamIndex]["txtValue"] = logicalMerchantId;
            }
            parameter = dummy;
          } else {
            alert("Needed Logical Merchant ID");
            errorCount++;
          }
        }

        // Validate and include Cellpay sub-options when Cellpay is active
        const cellpay = ituChildren.find((c) => c?.metaKey === "ITU_CELLPAY");
        if (cellpay?.selectedValue === true) {
          const cpRecharge =
            cellpay?.childList?.find((c) => c?.metaKey === "CELLPAY_RECHARGE")
              ?.selectedValue || false;
          const cpBill =
            cellpay?.childList?.find((c) => c?.metaKey === "CELLPAY_BILLPAYMENT")
              ?.selectedValue || false;
          const cpPricingType = cellpay?.["CELLPAY_MERCHANT_PRICING_TYPE"];
          const allowedPricingTypes = ["CellPay_Pricing", "SpacePointe_Pricing"];

          if (!allowedPricingTypes.includes(cpPricingType)) {
            alert("Please select CellPay Merchant Pricing type.");
            errorCount++;
          }

          if (!cpRecharge && !cpBill) {
            alert("Select at least one Cellpay option (Recharge or Bill Payment).");
            errorCount++;
          }

          // Validate cellpay merchant fee limits
          const cpMerchantFee = cellpay?.["cellpayMerchantFee"];
          const cpFeeLimits = cellpay?.["cellpayfeelimit"]?.data?.limitList || [];
          const rechargeLimitObj = cpFeeLimits.find(l => l.configurationId === "CP_TOUP_FEE_LIMIT");
          const billpayLimitObj = cpFeeLimits.find(l => l.configurationId === "CP_BILLPAY_FEE_LIMIT");
          const maxRechargeFee = rechargeLimitObj ? Number(rechargeLimitObj.defaultValue) : Infinity;
          const maxBillpayFee = billpayLimitObj ? Number(billpayLimitObj.defaultValue) : Infinity;

          if ((cpRecharge || cpBill) && (!cpMerchantFee || cpMerchantFee.length === 0)) {
            alert("Cellpay merchant fee configuration is missing.");
            errorCount++;
          }

          if (cpMerchantFee && cpMerchantFee.length > 0) {
            cpMerchantFee.forEach((fee) => {
              if (cpRecharge) {
                if (!isValidCellpayFee(fee.CELLPAY_MERCHANT_RECHARGE_FEE_LIMIT, maxRechargeFee)) {
                  alert(`Store "${fee.locationName || 'Merchant'}" Recharge fee must be greater than 0 and up to ${maxRechargeFee}.`);
                  errorCount++;
                }

                const rechargeShareError = getCellpayProfitShareError(
                  "RECHARGE",
                  fee.CELLPAY_MERCHANT_RECHARGE_PROFIT_SHARE,
                  fee.CELLPAY_SPACEPOINTE_RECHARGE_PROFIT_SHARE
                );
                if (rechargeShareError) {
                  alert(`Store "${fee.locationName || 'Merchant'}" Recharge: ${rechargeShareError}`);
                  errorCount++;
                }
              }
              if (cpBill) {
                const billpayFeeError = getCellpayBillpayFeeError(
                  fee.CELLPAY_MERCHANT_BILLPAY_FEE_LIMIT,
                  maxBillpayFee
                );
                if (billpayFeeError) {
                  alert(`Store "${fee.locationName || 'Merchant'}" ${billpayFeeError}`);
                  errorCount++;
                }

                const billpayShareError = getCellpayProfitShareError(
                  "BILLPAY",
                  fee.CELLPAY_MERCHANT_BILLPAY_PROFIT_SHARE,
                  fee.CELLPAY_SPACEPOINTE_BILLPAY_PROFIT_SHARE
                );
                if (billpayShareError) {
                  alert(`Store "${fee.locationName || 'Merchant'}" Bill Pay: ${billpayShareError}`);
                  errorCount++;
                }
              }
            });
          }

          parameter.push({ metaKey: "CELLPAY_RECHARGE", metaValue: cpRecharge });
          parameter.push({ metaKey: "CELLPAY_BILLPAYMENT", metaValue: cpBill });
          parameter.push({
            metaKey: "CELLPAY_MERCHANT_PRICING_TYPE",
            metaValue: cpPricingType,
          });

          if (cpMerchantFee && cpMerchantFee.length > 0) {
            parameter.push({ metaKey: "CELLPAY_MERCHANT_FEE", metaValue: JSON.stringify(cpMerchantFee) });
          }
        }
      }
    }

    if (indexFinder("MERCHANT_PROCESSING", parameter) == 0) {
      console.log("CALLED");
      if (
        merchant[indexFinder("MERCHANT_PROCESSING", merchant)]?.selectedValue ==
        true
      ) {
        let mp = merchant[
          indexFinder("MERCHANT_PROCESSING", merchant)
        ]?.childList?.map((e) => ({
          metaKey: e.metaKey,
          metaValue: e.selectedValue,
        }));
        parameter.push(mp[0]);
        parameter.push(mp[1]);
        if (
          merchant[indexFinder("MERCHANT_PROCESSING", merchant)]?.childList[1]
            ?.selectedValue == true
        ) {
          let typeList =
            merchant[indexFinder("MERCHANT_PROCESSING", merchant)]?.childList[1]
              ?.chargeTypeList;
          let smp = typeList?.map((e) => ({
            metaKey: e.metaKey,
            metaValue: e.selectedValue,
          }));
          parameter.push(smp[0]);
          parameter.push(smp[1]);
          if (typeList[0]?.selectedValue == true) {
            let txtValue = typeList?.[0][typeList?.[0]["metaKey"]];
            let dummy = [...parameter];
            if (txtValue != "" && txtValue != undefined) {
              dummy[indexFinder("SURCHARGE", parameter)]["txtValue"] = txtValue;
              delete dummy[indexFinder("CASH_DISCOUNT", parameter)]["txtValue"];
            } else {
              alert("Needed Surcharge");
              errorCount++;
            }
            parameter = dummy;
          } else if (typeList[1]?.selectedValue == true) {
            let txtValue = typeList?.[1][typeList?.[1]["metaKey"]];
            let dummy = [...parameter];
            if (txtValue != "" && txtValue != undefined) {
              dummy[indexFinder("CASH_DISCOUNT", parameter)]["txtValue"] =
                txtValue;
              delete dummy[indexFinder("SURCHARGE", parameter)]["txtValue"];
            } else {
              alert("Needed Cash Discount");
              errorCount++;
            }
            parameter = dummy;
          }
        }
      }
    }

    // Comparing That Should We Get Shopify Id Based On Selected Items
    let priceValidator = (data) => {
      let count = 0;
      data.forEach((e) => {
        if (totalPriceParameter.includes(e)) {
          count++;
        }
      });
      return count;
    };

    if (errorCount == 0) {
      if (
        priceValidator(shopifyCount) < priceValidator(extraForShopify) &&
        countryId == 1
      ) {
        let shopifyId = prompt("ENTER SHOPIFY ID");
        if (shopifyId) {
          console.log("FINAL SHOP", parameter, shopifyId);
          postData(parameter, shopifyId);
        }
      } else {
        console.log("FINAL", parameter);
        postData(parameter, "");
      }
    }
  };

  const postData = async (parameter, value) => {
    setLoader(true);
    const employeeId = JSON.parse(
      sessionStorage.getItem("userData")
    )?.employeeId;
    // let body = {
    //   organizationId: id,
    //   employeeId: employeeId,
    //   parameters: parameter,
    // }
    // if(value !== ""){
    //   body["shopifyId"] = value
    // }
    const formData = new FormData();
    let changedParams =
      "[" + parameter.map((e) => JSON.stringify(e) + ",").join(""); //send array as a whole
    let lastComma = changedParams.substring(0, changedParams.length - 1) + "]"; // Manipulated

    formData.append("organizationId", id);
    formData.append("employeeId", employeeId);
    formData.append("parameters", lastComma);
    if (value !== "") {
      formData.append("shopifyId", value);
    }
    try {
      // let res = await AxiosService.post(`/support/merchant/post-parameter`,body
      // );

      let res = await axios.post(
        `${process.env.REACT_APP_ROOT_URL}/apiv11/auth/updatemerchantparamsbyid`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: `Basic ${process.env.REACT_APP_PHP_Auth_Token}`,
          },
        }
      );

      if (res.data.success == 1) {
        setLoader(false);
        history.goBack();
      } else {
        setLoader(false);
        alert(res.data.message);
      }
    } catch (error) {
      setLoader(false);
      alert(JSON.stringify(error.response));
      console.log(error);
    }
  };

  useEffect(() => {
    getMerchantParameters("");
  }, []);

  const ituCellpay = getNeededParams("ITU")?.childList?.find(
    (child) => child?.metaKey === "ITU_CELLPAY"
  );
  const ituLogical = getNeededParams("ITU")?.childList?.find(
    (child) => child?.metaKey === "ITU_LOGICAL"
  );

  const ituOthers = getNeededParams("ITU")?.childList?.find(
    (child) => child?.metaKey === "ITU_OTHERS"
  );

  return (
    <div className="adminContentSection">
      <Row gutter={8} className="mb-02">
        <Col span={24}>
          <div className="displayFlex mt10 mb-05 spaceBetween">
            <Button
              type="warning"
              className="mr-3 btn--large d-flex align-items-center"
              onClick={() => {
                history.goBack();
              }}
            >
              <ArrowLeftOutlined /> Back
            </Button>
          </div>
        </Col>
      </Row>
      <Row gutter={8} className="mb-02">
        <Col span={24}>
          <div className="bg-white p-2 merchantParameterBox">
            <h4 className="fs--1 fw-600">Merchant Parameters</h4>
            {/* Software Type Has Been Disabled On Click - onClick={()=>getMerchantParameters(e?.metaKey)} */}
            {productType?.length > 0 && (
              <>
                <p className="mb-05">Software Type</p>
                <div className="mb-1">
                  {productType.map((e, i) => {
                    return (
                      <div key={i}>
                        <input
                          type="radio"
                          name="softwareType"
                          value={e?.metaKey}
                          id={e?.metaKey}
                          defaultChecked={e?.metaValue == "true" ? true : false}
                          disabled
                        />
                        &nbsp; <label htmlFor={e?.metaKey}>{e?.metaKey}</label>
                        <br />
                      </div>
                    );
                  })}
                </div>
              </>
            )}
            <p className="mb-05">Merchant Parameters -- </p>
            <Row gutter={8} className="mb-02">
              {getNeededParams("MERCHANT_PROCESSING") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"MERCHANT_PROCESSING"}
                      value="Merchant Processing"
                      id="merchantProcessing"
                      defaultChecked={
                        getNeededParams("MERCHANT_PROCESSING")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="merchantProcessing">
                      Merchant Processing ({currency}
                      {getNeededParams("MERCHANT_PROCESSING")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("RESTAURANT") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"RESTAURANT"}
                      value="restaurant"
                      id="restaurant"
                      defaultChecked={
                        getNeededParams("RESTAURANT")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="restaurant">
                      Restaurant ({currency}
                      {getNeededParams("RESTAURANT")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {isUsOrUkMerchant &&
                getNeededParams("RESTAURANT")?.selectedValue == true &&
                getNeededParamsByKeys(["ONLINE_ORDER", "online_order"]) && (
                  <Col span={24} className="mb-02 ml-18">
                    <div className="d-flex mb-02 alignCenter">
                      <input
                        type="checkbox"
                        name={
                          getNeededParamsByKeys(["ONLINE_ORDER", "online_order"])
                            ?.metaKey
                        }
                        value="onlineOrder"
                        id="onlineOrder"
                        defaultChecked={
                          getNeededParamsByKeys(["ONLINE_ORDER", "online_order"])
                            ?.selectedValue
                        }
                        onClick={(e) =>
                          handleCheckBox(e.target.name, e.target.checked)
                        }
                      />{" "}
                      <label className="ml-05" htmlFor="onlineOrder">
                        Online Orders
                      </label>
                    </div>
                  </Col>
                )}
              {getNeededParams("MERCHANT_PROCESSING") &&
                getNeededParams("MERCHANT_PROCESSING")?.selectedValue ==
                true && (
                  <div>
                    <Col span={24} className="mb-02 ml-18">
                      <input
                        type="radio"
                        defaultChecked={
                          getNeededParams("MERCHANT_PROCESSING")?.childList[0]
                            ?.selectedValue
                        }
                        name={"MERCHANT_PROCESSING"}
                        id="noProcessing"
                        onClick={(e) => handleLevelOneRadio(e.target.name, 1)}
                      />{" "}
                      <label htmlFor="noProcessing">No Processing</label>
                      <br />
                      <input
                        type="radio"
                        defaultChecked={
                          getNeededParams("MERCHANT_PROCESSING")?.childList[1]
                            ?.selectedValue
                        }
                        name={"MERCHANT_PROCESSING"}
                        id="Standard Processing"
                        onClick={(e) => handleLevelOneRadio(e.target.name, 2)}
                      />{" "}
                      <label htmlFor="Standard Processing">
                        Standard Processing
                      </label>
                    </Col>
                    {getNeededParams("MERCHANT_PROCESSING")?.childList[1]
                      ?.selectedValue == true && (
                        <Col span={24} className="mb-02 ml-36">
                          <span className="mr-5">
                            <input
                              type="radio"
                              name={
                                getNeededParams("MERCHANT_PROCESSING")
                                  ?.childList[1]?.metaKey
                              }
                              id="Surcharge"
                              defaultChecked={
                                getNeededParams("MERCHANT_PROCESSING")
                                  ?.childList[1]?.chargeTypeList[0]?.selectedValue
                              }
                              onChange={() => handleLevelTwoRadio(1)}
                            />{" "}
                            <label htmlFor="Surcharge">Surcharge</label>
                          </span>
                          <span>
                            <input
                              type="radio"
                              name={
                                getNeededParams("MERCHANT_PROCESSING")
                                  ?.childList[1]?.metaKey
                              }
                              id="Dual Pricing"
                              defaultChecked={
                                getNeededParams("MERCHANT_PROCESSING")
                                  ?.childList[1]?.chargeTypeList[1]?.selectedValue
                              }
                              onChange={() => handleLevelTwoRadio(2)}
                            />{" "}
                            <label htmlFor="Dual Pricing">Dual Pricing</label>
                          </span>
                          {getNeededParams("MERCHANT_PROCESSING")?.childList[1]
                            ?.chargeTypeList[0]?.selectedValue === true && (
                              <div className="mb-1 merchantTextBox">
                                <label
                                  className="text--grey fw-600"
                                  htmlFor="creditCardSurcharge"
                                >
                                  Credit Card Surcharge
                                </label>
                                <br />
                                <input
                                  type="text"
                                  name={
                                    getNeededParams("MERCHANT_PROCESSING")
                                      ?.childList[1]?.chargeTypeList[0]?.metaKey
                                  }
                                  defaultValue={
                                    getNeededParams("MERCHANT_PROCESSING")
                                      ?.childList[1]?.chargeTypeList[0][
                                    getNeededParams("MERCHANT_PROCESSING")
                                      ?.childList[1]?.chargeTypeList[0]?.metaKey
                                    ]
                                  }
                                  className="form-control"
                                  id="creditCardSurcharge"
                                  onChange={(e) =>
                                    handleLevelThreeInput(
                                      e.target.name,
                                      e.target.value,
                                      1
                                    )
                                  }
                                />
                              </div>
                            )}
                          {getNeededParams("MERCHANT_PROCESSING")?.childList[1]
                            ?.chargeTypeList[1]?.selectedValue === true && (
                              <div>
                                <div className="d-flex">
                                  <div className="mb-1 mr-5 merchantTextBox">
                                    <label
                                      className="text--grey fw-600"
                                      htmlFor="Interchange Fee Percentage"
                                    >
                                      Interchange Fee Percentage
                                    </label>
                                    <br />
                                    <input
                                      type="text"
                                      name={
                                        getNeededParams("MERCHANT_PROCESSING")
                                          ?.childList[1]?.chargeTypeList[1]?.metaKey
                                      }
                                      defaultValue={
                                        getNeededParams("MERCHANT_PROCESSING")
                                          ?.childList[1]?.chargeTypeList[1][
                                        getNeededParams("MERCHANT_PROCESSING")
                                          ?.childList[1]?.chargeTypeList[1]
                                          ?.metaKey
                                        ]
                                      }
                                      className="form-control"
                                      id="Interchange Fee Percentage"
                                      onChange={(e) =>
                                        handleLevelThreeInput(
                                          e.target.name,
                                          e.target.value,
                                          2
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                        </Col>
                      )}
                  </div>
                )}
            </Row>
            {/* Multi Store Has Been Disabled - onClick={(e)=>handleCheckBox(e.target.name, e.target.checked)}*/}
            <Row gutter={8} className="mb-02">
              {getNeededParams("CHANGE_TO_MULTI_STORE_MANAGEMENT") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"CHANGE_TO_MULTI_STORE_MANAGEMENT"}
                      value="Multistore"
                      id="Multistore"
                      defaultChecked={
                        getNeededParams("CHANGE_TO_MULTI_STORE_MANAGEMENT")
                          ?.selectedValue
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="Multistore">
                      Multistore ({currency}
                      {
                        getNeededParams("CHANGE_TO_MULTI_STORE_MANAGEMENT")
                          ?.amount
                      }
                      )
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("ADD_STAFF_MANAGEMENT") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"ADD_STAFF_MANAGEMENT"}
                      value="staffManagement"
                      id="staffManagement"
                      defaultChecked={
                        getNeededParams("ADD_STAFF_MANAGEMENT")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="staffManagement">
                      Staff Management ({currency}
                      {getNeededParams("ADD_STAFF_MANAGEMENT")?.amount})
                    </label>
                  </div>
                </Col>
              )}
            </Row>
            <Row gutter={8} className="mb-02">
              {getNeededParams("ADD_KARDSTASH") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"ADD_KARDSTASH"}
                      value="kardStash"
                      id="kardStash"
                      defaultChecked={
                        getNeededParams("ADD_KARDSTASH")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="kardStash">
                      KardStash ({currency}
                      {getNeededParams("ADD_KARDSTASH")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("ADD_CUSTOMER_MANAGEMENT") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"ADD_CUSTOMER_MANAGEMENT"}
                      value="customerManagement"
                      id="customerManagement"
                      defaultChecked={
                        getNeededParams("ADD_CUSTOMER_MANAGEMENT")
                          ?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="customerManagement">
                      Customer Management ({currency}
                      {getNeededParams("ADD_CUSTOMER_MANAGEMENT")?.amount})
                    </label>
                  </div>
                </Col>
              )}
            </Row>
            <Row gutter={8} className="mb-02">
              {getNeededParams("ADD_DISCOUNT_MANAGEMENT") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"ADD_DISCOUNT_MANAGEMENT"}
                      value="discountManagement"
                      id="discountManagement"
                      defaultChecked={
                        getNeededParams("ADD_DISCOUNT_MANAGEMENT")
                          ?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="discountManagement">
                      Discount Management ({currency}
                      {getNeededParams("ADD_DISCOUNT_MANAGEMENT")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("MASTER_CATALOG") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"MASTER_CATALOG"}
                      value="masterCatalog"
                      id="masterCatalog"
                      defaultChecked={
                        getNeededParams("MASTER_CATALOG")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="masterCatalog">
                      Master Catalog ({currency}
                      {getNeededParams("MASTER_CATALOG")?.amount})
                    </label>
                  </div>
                </Col>
              )}
            </Row>
            <Row gutter={8} className="mb-02">
              {getNeededParams("ITU") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"ITU"}
                      value="ITU"
                      id="ITU"
                      defaultChecked={getNeededParams("ITU")?.selectedValue}
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="ITU">
                      Prepaid ({currency}
                      {getNeededParams("ITU")?.amount})
                    </label>
                  </div>

                  {getNeededParams("ITU") &&
                    getNeededParams("ITU")?.selectedValue == true && (
                      <div>
                        <Col span={24} className="mb-02 ml-18">
                          {countryId != 3 && (
                            <>
                              <input
                                type="radio"
                                name={"ITU"}
                                id="Logical"
                                defaultChecked={
                                  ituLogical?.selectedValue
                                }
                                onClick={(e) => handleLevelOneRadio(e.target.name, 1)}
                              />{" "}
                              <label htmlFor="Logical">Logical</label>
                              <br />
                            </>
                          )}
                          <input
                            type="radio"
                            name={"ITU"}
                            id="Others"
                            defaultChecked={
                              ituOthers?.selectedValue
                            }
                            onClick={(e) => handleLevelOneRadio(e.target.name, 2)}
                          />{" "}
                          <label htmlFor="Others">
                            Others ( prepay nation & lunex)
                          </label>


                          {countryId != 3 && (
                            <>
                              <br />
                              <input
                                type="radio"
                                name={"ITU"}
                                id="Cellpay"
                                defaultChecked={
                                  ituCellpay?.selectedValue
                                }
                                onClick={(e) => handleLevelOneRadio(e.target.name, 3)}
                              />{" "}
                              <label htmlFor="Cellpay">
                                Cellpay
                              </label>
                            </>
                          )}
                        </Col>

                        {countryId != 3 && ituLogical?.selectedValue ==
                          true && (
                            <Col span={24}>
                              <div className="ml-36 mb-1 merchantTextBox">
                                <label
                                  className="text--grey fw-600"
                                  htmlFor="logicalMerchantID"
                                >
                                  Logical Merchant ID
                                </label>
                                <br />
                                <input
                                  type="text"
                                  name={"LOGICAL_MERCHANT_ID"}
                                  defaultValue={
                                    ituLogical?.LOGICAL_MERCHANT_ID ||
                                    ituLogical?.[ituLogical?.metaKey]
                                  }
                                  onChange={(e) =>
                                    handleLogicalMerchantInput(e.target.value)
                                  }
                                  className="form-control"
                                  id="logicalMerchantID"
                                />
                              </div>
                            </Col>
                          )}
                        {countryId != 3 && ituCellpay?.selectedValue ===
                          true && (
                            <Col span={24}>
                              <div className="ml-36 mb-1 merchantTextBox">
                                <label className="text--grey fw-600" htmlFor="cellpayOptions">
                                  Cellpay Options <span style={{ color: 'red' }}>*</span>
                                </label>
                                <br />
                                <div id="cellpayOptions">
                                  {(() => {
                                    const cpFeeLimits = ituCellpay?.cellpayfeelimit?.data?.limitList || [];
                                    const rechargeLimitObj = cpFeeLimits.find(l => l.configurationId === "CP_TOUP_FEE_LIMIT");
                                    const billpayLimitObj = cpFeeLimits.find(l => l.configurationId === "CP_BILLPAY_FEE_LIMIT");
                                    const maxRechargeFee = rechargeLimitObj ? Number(rechargeLimitObj.defaultValue) : Infinity;
                                    const maxBillpayFee = billpayLimitObj ? Number(billpayLimitObj.defaultValue) : Infinity;

                                    return (
                                      <>
                                        <div className="mb-1">
                                          <div className="d-flex alignCenter mb-05">
                                            <input
                                              type="checkbox"
                                              name={"CELLPAY_RECHARGE"}
                                              id="cellpayRecharge"
                                              defaultChecked={
                                                ituCellpay?.childList?.[0]?.selectedValue || false
                                              }
                                              onChange={(e) => handleCellpayCheckbox(e.target.name, e.target.checked)}
                                            />{" "}
                                            <label htmlFor="cellpayRecharge" className="ml-05 fw-600">Mobile Recharge</label>
                                          </div>

                                          {ituCellpay?.childList?.[0]?.selectedValue &&
                                            (() => {
                                              const feeList = ituCellpay?.cellpayMerchantFee || [];
                                              const multiLocation = feeList.length > 1;
                                              const store = feeList[0] || {};
                                              const isFeeInvalid = !isValidCellpayFee(
                                                store.CELLPAY_MERCHANT_RECHARGE_FEE_LIMIT,
                                                maxRechargeFee
                                              );
                                              const rechargeShareError = getCellpayProfitShareError(
                                                "RECHARGE",
                                                store.CELLPAY_MERCHANT_RECHARGE_PROFIT_SHARE,
                                                store.CELLPAY_SPACEPOINTE_RECHARGE_PROFIT_SHARE
                                              );
                                              const merchantRechargeShareError = getCellpayProfitShareFieldError(
                                                "RECHARGE",
                                                store.CELLPAY_MERCHANT_RECHARGE_PROFIT_SHARE
                                              );
                                              const spacepointeRechargeShareError = getCellpayProfitShareFieldError(
                                                "RECHARGE",
                                                store.CELLPAY_SPACEPOINTE_RECHARGE_PROFIT_SHARE
                                              );
                                              const showRechargeRowError =
                                                rechargeShareError &&
                                                !merchantRechargeShareError &&
                                                !spacepointeRechargeShareError;

                                              if (multiLocation) {
                                                return (
                                                  <div className="ml-18 mb-1">
                                                    <div className="d-flex" style={{ gap: '24px', width: '100%' }}>
                                                      <div style={{ flex: 1, minWidth: '120px' }}>
                                                        <label className="text--grey" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>Fee</label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          style={{ padding: '8px' }}
                                                          value={store.CELLPAY_MERCHANT_RECHARGE_FEE_LIMIT || ""}
                                                          onChange={(e) => updateCellpayStoreFieldForAll("CELLPAY_MERCHANT_RECHARGE_FEE_LIMIT", sanitizeCurrency(e.target.value))}
                                                        />
                                                        {isFeeInvalid && (
                                                          <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                            Recharge fee must be greater than 0 and up to {maxRechargeFee}.
                                                          </div>
                                                        )}
                                                      </div>
                                                      <div style={{ flex: 1, minWidth: '120px' }}>
                                                        <label className="text--grey" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>Merchant %</label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          style={{ padding: '8px' }}
                                                          value={store.CELLPAY_MERCHANT_RECHARGE_PROFIT_SHARE || ""}
                                                          onChange={(e) => updateCellpayProfitSharesForAll("RECHARGE", "MERCHANT", e.target.value)}
                                                        />
                                                        {merchantRechargeShareError && (
                                                          <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                            {merchantRechargeShareError}
                                                          </div>
                                                        )}
                                                      </div>
                                                      <div style={{ flex: 1, minWidth: '120px' }}>
                                                        <label className="text--grey" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>Spacepointe %</label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          style={{ padding: '8px' }}
                                                          value={store.CELLPAY_SPACEPOINTE_RECHARGE_PROFIT_SHARE || ""}
                                                          onChange={(e) => updateCellpayProfitSharesForAll("RECHARGE", "SPACEPOINTE", e.target.value)}
                                                        />
                                                        {spacepointeRechargeShareError && (
                                                          <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                            {spacepointeRechargeShareError}
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>
                                                    {showRechargeRowError && (
                                                      <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                        {rechargeShareError}
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              }

                                              return feeList.map((store, idx) => {
                                                const isFeeInvalid = !isValidCellpayFee(
                                                  store.CELLPAY_MERCHANT_RECHARGE_FEE_LIMIT,
                                                  maxRechargeFee
                                                );
                                                const rechargeShareError = getCellpayProfitShareError(
                                                  "RECHARGE",
                                                  store.CELLPAY_MERCHANT_RECHARGE_PROFIT_SHARE,
                                                  store.CELLPAY_SPACEPOINTE_RECHARGE_PROFIT_SHARE
                                                );
                                                const merchantRechargeShareError = getCellpayProfitShareFieldError(
                                                  "RECHARGE",
                                                  store.CELLPAY_MERCHANT_RECHARGE_PROFIT_SHARE
                                                );
                                                const spacepointeRechargeShareError = getCellpayProfitShareFieldError(
                                                  "RECHARGE",
                                                  store.CELLPAY_SPACEPOINTE_RECHARGE_PROFIT_SHARE
                                                );
                                                const showRechargeRowError =
                                                  rechargeShareError &&
                                                  !merchantRechargeShareError &&
                                                  !spacepointeRechargeShareError;
                                                return (
                                                  <div key={`recharge-${store.organizationId || idx}`} className="ml-18 mb-1">
                                                    <div className="d-flex" style={{ gap: '24px', width: '100%' }}>
                                                      <div style={{ flex: 1, minWidth: '120px' }}>
                                                        <label className="text--grey" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>Fee</label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          style={{ padding: '8px' }}
                                                          value={store.CELLPAY_MERCHANT_RECHARGE_FEE_LIMIT || ""}
                                                          onChange={(e) => updateCellpayStoreField(store.organizationId, "CELLPAY_MERCHANT_RECHARGE_FEE_LIMIT", sanitizeCurrency(e.target.value))}
                                                        />
                                                        {isFeeInvalid && (
                                                          <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                            Recharge fee must be greater than 0 and up to {maxRechargeFee}.
                                                          </div>
                                                        )}
                                                      </div>
                                                      <div style={{ flex: 1, minWidth: '120px' }}>
                                                        <label className="text--grey" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>Merchant %</label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          style={{ padding: '8px' }}
                                                          value={store.CELLPAY_MERCHANT_RECHARGE_PROFIT_SHARE || ""}
                                                          onChange={(e) => updateCellpayProfitShares(store.organizationId, "RECHARGE", "MERCHANT", e.target.value)}
                                                        />
                                                        {merchantRechargeShareError && (
                                                          <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                            {merchantRechargeShareError}
                                                          </div>
                                                        )}
                                                      </div>
                                                      <div style={{ flex: 1, minWidth: '120px' }}>
                                                        <label className="text--grey" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>Spacepointe %</label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          style={{ padding: '8px' }}
                                                          value={store.CELLPAY_SPACEPOINTE_RECHARGE_PROFIT_SHARE || ""}
                                                          onChange={(e) => updateCellpayProfitShares(store.organizationId, "RECHARGE", "SPACEPOINTE", e.target.value)}
                                                        />
                                                        {spacepointeRechargeShareError && (
                                                          <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                            {spacepointeRechargeShareError}
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>
                                                    {showRechargeRowError && (
                                                      <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                        {rechargeShareError}
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              });
                                            })()}
                                        </div>

                                        <div className="mb-1">
                                          <div className="d-flex alignCenter mb-05">
                                            <input
                                              type="checkbox"
                                              name={"CELLPAY_BILLPAYMENT"}
                                              id="cellpayBillpayment"
                                              defaultChecked={
                                                ituCellpay?.childList?.[1]?.selectedValue || false
                                              }
                                              onChange={(e) => handleCellpayCheckbox(e.target.name, e.target.checked)}
                                            />{" "}
                                            <label htmlFor="cellpayBillpayment" className="ml-05 fw-600">Bill Pay</label>
                                          </div>

                                          {ituCellpay?.childList?.[1]?.selectedValue &&
                                            (() => {
                                              const feeList = ituCellpay?.cellpayMerchantFee || [];
                                              const multiLocation = feeList.length > 1;
                                              const store = feeList[0] || {};
                                              const billpayFeeError = getCellpayBillpayFeeError(
                                                store.CELLPAY_MERCHANT_BILLPAY_FEE_LIMIT,
                                                maxBillpayFee
                                              );
                                              const billpayShareError = getCellpayProfitShareError(
                                                "BILLPAY",
                                                store.CELLPAY_MERCHANT_BILLPAY_PROFIT_SHARE,
                                                store.CELLPAY_SPACEPOINTE_BILLPAY_PROFIT_SHARE
                                              );
                                              const merchantBillpayShareError = getCellpayProfitShareFieldError(
                                                "BILLPAY",
                                                store.CELLPAY_MERCHANT_BILLPAY_PROFIT_SHARE
                                              );
                                              const spacepointeBillpayShareError = getCellpayProfitShareFieldError(
                                                "BILLPAY",
                                                store.CELLPAY_SPACEPOINTE_BILLPAY_PROFIT_SHARE
                                              );
                                              const showBillpayRowError =
                                                billpayShareError &&
                                                !merchantBillpayShareError &&
                                                !spacepointeBillpayShareError;

                                              if (multiLocation) {
                                                return (
                                                  <div className="ml-18 mb-1">
                                                    <div className="d-flex" style={{ gap: '24px', width: '100%' }}>
                                                      <div style={{ flex: 1, minWidth: '120px' }}>
                                                        <label className="text--grey" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>Fee</label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          style={{ padding: '8px' }}
                                                          value={store.CELLPAY_MERCHANT_BILLPAY_FEE_LIMIT || ""}
                                                          onChange={(e) => updateCellpayStoreFieldForAll("CELLPAY_MERCHANT_BILLPAY_FEE_LIMIT", sanitizeCurrency(e.target.value))}
                                                        />
                                                        {billpayFeeError && (
                                                          <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                            {billpayFeeError}
                                                          </div>
                                                        )}
                                                      </div>
                                                      <div style={{ flex: 1, minWidth: '120px' }}>
                                                        <label className="text--grey" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>Merchant %</label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          style={{ padding: '8px' }}
                                                          value={store.CELLPAY_MERCHANT_BILLPAY_PROFIT_SHARE || ""}
                                                          onChange={(e) => updateCellpayProfitSharesForAll("BILLPAY", "MERCHANT", e.target.value)}
                                                        />
                                                        {merchantBillpayShareError && (
                                                          <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                            {merchantBillpayShareError}
                                                          </div>
                                                        )}
                                                      </div>
                                                      <div style={{ flex: 1, minWidth: '120px' }}>
                                                        <label className="text--grey" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>Spacepointe %</label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          style={{ padding: '8px' }}
                                                          value={store.CELLPAY_SPACEPOINTE_BILLPAY_PROFIT_SHARE || ""}
                                                          onChange={(e) => updateCellpayProfitSharesForAll("BILLPAY", "SPACEPOINTE", e.target.value)}
                                                        />
                                                        {spacepointeBillpayShareError && (
                                                          <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                            {spacepointeBillpayShareError}
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>
                                                    {showBillpayRowError && (
                                                      <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                        {billpayShareError}
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              }

                                              return feeList.map((store, idx) => {
                                                const billpayFeeError = getCellpayBillpayFeeError(
                                                  store.CELLPAY_MERCHANT_BILLPAY_FEE_LIMIT,
                                                  maxBillpayFee
                                                );
                                                const billpayShareError = getCellpayProfitShareError(
                                                  "BILLPAY",
                                                  store.CELLPAY_MERCHANT_BILLPAY_PROFIT_SHARE,
                                                  store.CELLPAY_SPACEPOINTE_BILLPAY_PROFIT_SHARE
                                                );
                                                const merchantBillpayShareError = getCellpayProfitShareFieldError(
                                                  "BILLPAY",
                                                  store.CELLPAY_MERCHANT_BILLPAY_PROFIT_SHARE
                                                );
                                                const spacepointeBillpayShareError = getCellpayProfitShareFieldError(
                                                  "BILLPAY",
                                                  store.CELLPAY_SPACEPOINTE_BILLPAY_PROFIT_SHARE
                                                );
                                                const showBillpayRowError =
                                                  billpayShareError &&
                                                  !merchantBillpayShareError &&
                                                  !spacepointeBillpayShareError;
                                                return (
                                                  <div key={`billpay-${store.organizationId || idx}`} className="ml-18 mb-1">
                                                    <div className="d-flex" style={{ gap: '24px', width: '100%' }}>
                                                      <div style={{ flex: 1, minWidth: '120px' }}>
                                                        <label className="text--grey" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>Fee</label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          style={{ padding: '8px' }}
                                                          value={store.CELLPAY_MERCHANT_BILLPAY_FEE_LIMIT || ""}
                                                          onChange={(e) => updateCellpayStoreField(store.organizationId, "CELLPAY_MERCHANT_BILLPAY_FEE_LIMIT", sanitizeCurrency(e.target.value))}
                                                        />
                                                        {billpayFeeError && (
                                                          <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                            {billpayFeeError}
                                                          </div>
                                                        )}
                                                      </div>
                                                      <div style={{ flex: 1, minWidth: '120px' }}>
                                                        <label className="text--grey" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>Merchant %</label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          style={{ padding: '8px' }}
                                                          value={store.CELLPAY_MERCHANT_BILLPAY_PROFIT_SHARE || ""}
                                                          onChange={(e) => updateCellpayProfitShares(store.organizationId, "BILLPAY", "MERCHANT", e.target.value)}
                                                        />
                                                        {merchantBillpayShareError && (
                                                          <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                            {merchantBillpayShareError}
                                                          </div>
                                                        )}
                                                      </div>
                                                      <div style={{ flex: 1, minWidth: '120px' }}>
                                                        <label className="text--grey" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>Spacepointe %</label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          style={{ padding: '8px' }}
                                                          value={store.CELLPAY_SPACEPOINTE_BILLPAY_PROFIT_SHARE || ""}
                                                          onChange={(e) => updateCellpayProfitShares(store.organizationId, "BILLPAY", "SPACEPOINTE", e.target.value)}
                                                        />
                                                        {spacepointeBillpayShareError && (
                                                          <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                            {spacepointeBillpayShareError}
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>
                                                    {showBillpayRowError && (
                                                      <div className="mt-05" style={{ color: 'red', fontSize: '12px' }}>
                                                        {billpayShareError}
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              });
                                            })()}
                                        </div>
                                      </>
                                    );
                                  })()}



                                  <div className="mt-1 merchantTextBox">
                                    <label className="fw-600">
                                      CellPay Merchant Pricing <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <div className="alignCenter mt-05" style={{ gap: '16px' }}>
                                      {resellerId != null &&
                                        <div>
                                          <input
                                            type="radio"
                                            id="cellpayPricingTypeCellpay"
                                            name="CELLPAY_MERCHANT_PRICING_TYPE"
                                            value="CellPay_Pricing"
                                            checked={
                                              ituCellpay?.CELLPAY_MERCHANT_PRICING_TYPE === "CellPay_Pricing"
                                            }
                                            onChange={(e) =>
                                              handleCellpayMerchantPricingTypeInput(e.target.value)
                                            }
                                          />{" "}
                                          <label htmlFor="cellpayPricingTypeCellpay">
                                            CellPay Pricing
                                          </label>
                                        </div>
                                      }

                                      <div>
                                        <input
                                          type="radio"
                                          id="cellpayPricingTypeSpacepointe"
                                          name="CELLPAY_MERCHANT_PRICING_TYPE"
                                          value="SpacePointe_Pricing"
                                          checked={
                                            ituCellpay?.CELLPAY_MERCHANT_PRICING_TYPE === "SpacePointe_Pricing"
                                          }
                                          onChange={(e) =>
                                            handleCellpayMerchantPricingTypeInput(e.target.value)
                                          }
                                        />{" "}
                                        <label htmlFor="cellpayPricingTypeSpacepointe">
                                          SpacePointe Pricing
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  {(() => {
                                    const cp = ituCellpay;
                                    const recharge = cp?.childList?.[0]?.selectedValue;
                                    const bill = cp?.childList?.[1]?.selectedValue;
                                    const invalid = cp?.selectedValue === true && !(recharge || bill);
                                    return invalid ? (
                                      <div className="mt-05" style={{ color: 'red' }}>
                                        Please select at least one Cellpay option.
                                      </div>
                                    ) : null;
                                  })()}
                                </div>
                              </div>
                            </Col>
                          )}

                      </div>
                    )}
                </Col>
              )}
              {/* {FOOD STAMP PROCESSING IS MISSING FROM API ADDED EDT FOR THAT CASE} */}
              {getNeededParams("EBT") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"EBT"}
                      value="foodStampProcessing"
                      id="foodStampProcessing"
                      defaultChecked={getNeededParams("EBT")?.selectedValue}
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="foodStampProcessing">
                      Food Stamp Processing ({currency}
                      {getNeededParams("EBT")?.amount})
                    </label>
                  </div>
                </Col>
              )}

            </Row>
            <Row gutter={8} className="mb-02">
              {getNeededParams("MULTI_LANGUAGE_SUPPORT") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"MULTI_LANGUAGE_SUPPORT"}
                      value="multiLanguageSupport"
                      id="multiLanguageSupport"
                      defaultChecked={
                        getNeededParams("MULTI_LANGUAGE_SUPPORT")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="multiLanguageSupport">
                      Multi Language Support ({currency}
                      {getNeededParams("MULTI_LANGUAGE_SUPPORT")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("RECORD_VOIDED_TRANSACTION") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"RECORD_VOIDED_TRANSACTION"}
                      value="recordVoidedTransaction"
                      id="recordVoidedTransaction"
                      defaultChecked={
                        getNeededParams("RECORD_VOIDED_TRANSACTION")
                          ?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="recordVoidedTransaction">
                      Record Voided Transaction ({currency}
                      {getNeededParams("RECORD_VOIDED_TRANSACTION")?.amount})
                    </label>
                  </div>
                </Col>
              )}
            </Row>
            <Row gutter={8} className="mb-02">
              {getNeededParams("TIP") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"TIP"}
                      value="Tip"
                      id="Tip"
                      defaultChecked={getNeededParams("TIP")?.selectedValue}
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="Tip">
                      Tip ({currency}
                      {getNeededParams("TIP")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("GEO_LOCK") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"GEO_LOCK"}
                      value="geoLock"
                      id="geoLock"
                      defaultChecked={
                        getNeededParams("GEO_LOCK")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="geoLock">
                      Geo lock ({currency}
                      {getNeededParams("GEO_LOCK")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("TIP") &&
                getNeededParams("TIP")?.selectedValue == true && (
                  <Col span={24} className="mb-02 ml-18">
                    <input
                      type="radio"
                      name={"TIP"}
                      id="Employee TIP"
                      defaultChecked={
                        getNeededParams("TIP")?.childList[0]?.selectedValue
                      }
                      onClick={(e) => handleLevelOneRadio(e.target.name, 1)}
                    />{" "}
                    <label htmlFor="Employee TIP">Employee TIP</label>
                    <br />
                    <input
                      type="radio"
                      name={"TIP"}
                      id="Common TIP"
                      defaultChecked={
                        getNeededParams("TIP")?.childList[1]?.selectedValue
                      }
                      onClick={(e) => handleLevelOneRadio(e.target.name, 2)}
                    />{" "}
                    <label htmlFor="Common TIP">Common TIP</label>
                  </Col>
                )}
            </Row>
            <Row gutter={8} className="mb-02">
              {getNeededParams("TIME_CLOCK_MANAGEMENT") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"TIME_CLOCK_MANAGEMENT"}
                      value="timeClockManagement"
                      id="timeClockManagement"
                      defaultChecked={
                        getNeededParams("TIME_CLOCK_MANAGEMENT")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="timeClockManagement">
                      Time Clock Management ({currency}
                      {getNeededParams("TIME_CLOCK_MANAGEMENT")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("WEB_ACCESS") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"WEB_ACCESS"}
                      value="webAccess"
                      id="webAccess"
                      defaultChecked={
                        getNeededParams("WEB_ACCESS")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="webAccess">
                      Web Access ({currency}
                      {getNeededParams("WEB_ACCESS")?.amount})
                    </label>
                  </div>
                </Col>
              )}
            </Row>
            <Row gutter={8} className="mb-02">
              {getNeededParams("LOYALTY") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"LOYALTY"}
                      value="Loyalty"
                      id="Loyalty"
                      defaultChecked={getNeededParams("LOYALTY")?.selectedValue}
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="Loyalty">
                      Loyalty ({currency}
                      {getNeededParams("LOYALTY")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("PRE_PAID_INVENTORY") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"PRE_PAID_INVENTORY"}
                      value="baseModelwithInventoryManagement"
                      id="baseModelwithInventoryManagement"
                      defaultChecked={
                        getNeededParams("PRE_PAID_INVENTORY")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label
                      className="ml-05"
                      htmlFor="baseModelwithInventoryManagement"
                    >
                      Base Model with Inventory Management ({currency}
                      {getNeededParams("PRE_PAID_INVENTORY")?.amount})
                    </label>
                  </div>
                </Col>
              )}
            </Row>
            <Row gutter={8} className="mb-02">
              {getNeededParams("BARS") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"BARS"}
                      value="barTab"
                      defaultChecked={getNeededParams("BARS")?.selectedValue}
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label htmlFor="barTab" className="ml-05">
                      Bar Tab ({currency}
                      {getNeededParams("BARS")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("Tabbacco_scan") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"Tabbacco_scan"}
                      value="tobaccoScanning"
                      id="tobaccoScanning"
                      defaultChecked={
                        getNeededParams("Tabbacco_scan")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="tobaccoScanning">
                      Tobacco Scanning ({currency}
                      {getNeededParams("Tabbacco_scan")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("BARS") &&
                getNeededParams("BARS")?.selectedValue == true && (
                  <Col span={24}>
                    <div className="ml-18 mb-1 merchantTextBox">
                      <label
                        className="text--grey fw-600"
                        htmlFor="preAuthAmount"
                      >
                        Pre Auth Amount
                      </label>
                      <br />
                      <input
                        type="text"
                        name={getNeededParams("BARS")?.metaKey}
                        value={
                          getNeededParams("BARS")[
                          getNeededParams("BARS")?.metaKey
                          ]
                        }
                        className="form-control"
                        id="preAuthAmount"
                        onChange={(e) => handleBarInput(e.target.value)}
                      />
                    </div>
                  </Col>
                )}
            </Row>
            <Row gutter={8} className="mb-02">
              {getNeededParams("CCTV") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"CCTV"}
                      value="CCTV"
                      id="CCTV"
                      defaultChecked={getNeededParams("CCTV")?.selectedValue}
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="CCTV">
                      CCTV ({currency}
                      {getNeededParams("CCTV")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("E_COMMERCE") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"E_COMMERCE"}
                      value="ECOMMERCE"
                      id="E-COMMERCE"
                      defaultChecked={
                        getNeededParams("E_COMMERCE")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label htmlFor="E-COMMERCE" className="ml-05">
                      E-COMMERCE ({currency}
                      {getNeededParams("E_COMMERCE")?.amount})
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("WareHouse_Management") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"WareHouse_Management"}
                      value="WareHouse_Management"
                      id="WareHouse_Management"
                      defaultChecked={
                        getNeededParams("WareHouse_Management")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label htmlFor="WareHouse_Management" className="ml-05">
                      WareHouse_Management
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("CreditCardFee") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"CreditCardFee"}
                      value="CreditCardFee"
                      id="CreditCardFee"
                      defaultChecked={
                        getNeededParams("CreditCardFee")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label htmlFor="CreditCardFee" className="ml-05">
                      Credit Card Fee
                    </label>
                  </div>
                </Col>
              )}
              {countryId == 236 && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"vatReturnReport"}
                      value="vatReturnReport"
                      id="vatReturnReport"
                      defaultChecked={
                        getNeededParams("vatReturnReport")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label htmlFor="vatReturnReport" className="ml-05">
                      Credit Card Fee
                    </label>
                  </div>
                </Col>
              )}
            </Row>
            <Row gutter={8} className="mb-02">
              {getNeededParams("SPA") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"SPA"}
                      value="SPA"
                      id="SPA"
                      defaultChecked={getNeededParams("SPA")?.selectedValue}
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="SPA">
                      SPA ({currency}
                      {getNeededParams("SPA")?.amount})
                    </label>
                  </div>
                </Col>
              )}
            </Row>
            <Row gutter={8} className="mb-02">
              {getNeededParams("ADD_DONATION_MANAGEMENT") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"ADD_DONATION_MANAGEMENT"}
                      value="ADD_DONATION_MANAGEMENT"
                      id="ADD_DONATION_MANAGEMENT"
                      defaultChecked={
                        getNeededParams("ADD_DONATION_MANAGEMENT")
                          ?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="ADD_DONATION_MANAGEMENT">
                      {
                        getNeededParams("ADD_DONATION_MANAGEMENT")
                          ?.parameterName
                      }
                    </label>
                  </div>
                </Col>
              )}
            </Row>
            <Row gutter={8} className="mb-02">
              {getNeededParams("RESTAURANTKIOSK") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"RESTAURANTKIOSK"}
                      value="RESTAURANTKIOSK"
                      id="RESTAURANT_KIOSK"
                      defaultChecked={
                        getNeededParams("RESTAURANTKIOSK")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="RESTAURANT_KIOSK">
                      Restaurant Kiosk
                    </label>
                  </div>
                </Col>
              )}
            </Row>

            <Row gutter={8} className="mb-02">
              {getNeededParams("DUALPRICING") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"DUALPRICING"}
                      value="DUALPRICING"
                      id="DUALPRICING_ID"
                      defaultChecked={
                        getNeededParams("DUALPRICING")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="DUALPRICING_ID">
                      Dual Pricing
                    </label>
                  </div>
                </Col>
              )}
              {getNeededParams("DUALPRICING") &&
                getNeededParams("DUALPRICING")?.selectedValue == true && (
                  <Col span={24} className="mb-02 ml-18">
                    <input
                      type="radio"
                      name={"DUALPRICING"}
                      id="display_card_price"
                      defaultChecked={
                        getNeededParams("DUALPRICING")?.childList[0]
                          ?.selectedValue
                      }
                      onClick={(e) => handleLevelOneRadio(e.target.name, 1)}
                    />{" "}
                    <label htmlFor="display_card_price">
                      Display Card Price
                    </label>
                    <br />
                    <input
                      type="radio"
                      name={"DUALPRICING"}
                      id="display_cash_price"
                      defaultChecked={
                        getNeededParams("DUALPRICING")?.childList[1]
                          ?.selectedValue
                      }
                      onClick={(e) => handleLevelOneRadio(e.target.name, 2)}
                    />{" "}
                    <label htmlFor="display_cash_price">
                      Display Cash Price
                    </label>
                  </Col>
                )}
            </Row>

            <Row gutter={8} className="mb-02">
              {getNeededParams("GROCERYKIOSK") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"GROCERYKIOSK"}
                      value="GROCERYKIOSK"
                      id="GROCERY_KIOSK"
                      defaultChecked={
                        getNeededParams("GROCERYKIOSK")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="GROCERY_KIOSK">
                      Grocery Kiosk
                    </label>
                  </div>
                </Col>
              )}
            </Row>

            <Row gutter={8} className="mb-02">
              {getNeededParams("CRYPTO") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"CRYPTO"}
                      value="CRYPTO"
                      id="CRYPTO_ID"
                      defaultChecked={getNeededParams("CRYPTO")?.selectedValue}
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="CRYPTO_ID">
                      Crypto Payments
                    </label>
                  </div>
                </Col>
              )}
            </Row>

            <Row gutter={8} className="mb-02">
              {getNeededParams("MEMBERSHIP") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"MEMBERSHIP"}
                      value="MEMBERSHIP"
                      id="MEMBERSHIP_ID"
                      defaultChecked={
                        getNeededParams("MEMBERSHIP")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="MEMBERSHIP_ID">
                      Membership Program
                    </label>
                  </div>
                </Col>
              )}
            </Row>

            <Row gutter={8} className="mb-02">
              {getNeededParams("ENABLEGIFTCARDS") && (
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name={"ENABLEGIFTCARDS"}
                      value="ENABLEGIFTCARDS"
                      id="ENABLE_GIFTCARDS"
                      defaultChecked={
                        getNeededParams("ENABLEGIFTCARDS")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />{" "}
                    <label className="ml-05" htmlFor="ENABLE_GIFTCARDS">
                      Gift Cards
                    </label>
                  </div>
                </Col>
              )}
            </Row>
            {countryId != 18 && (
              <Row gutter={8} className="mb-02">
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name="SKUPAY"
                      value="SKUPAY"
                      id="SKUPAY"
                      defaultChecked={
                        getNeededParams("SKUPAY")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />
                    <label className="ml-05" htmlFor="SKUPAY">
                      Skupay
                    </label>
                  </div>
                </Col>
              </Row>
            )}



            {/* QUICKBOOK */}
            {countryId != 18 && (
              <Row gutter={8} className="mb-02">
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name="QUICKBOOK"
                      value="QUICKBOOK"
                      id="QUICKBOOK"
                      defaultChecked={
                        getNeededParams("QUICKBOOK")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />
                    <label className="ml-05" htmlFor="QUICKBOOK">
                      QuickBook
                    </label>
                  </div>
                </Col>
              </Row>
            )}

            {/* PIN DEBIT - CASH BACK */}
            {countryId != 18 && (
              <Row gutter={8} className="mb-02">
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name="CASH_BACK"
                      value="CASH_BACK"
                      id="CASH_BACK"
                      defaultChecked={
                        getNeededParams("CASH_BACK")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />
                    <label className="ml-05" htmlFor="CASH_BACK">
                      PIN Debit – Cash Back
                    </label>
                  </div>
                </Col>
              </Row>
            )}

            {/* CUSTOMER_TAB */}
            {countryId != 18 && (
              <Row gutter={8} className="mb-02">
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name="CUSTOMER_TAB"
                      value="CUSTOMER_TAB"
                      id="CUSTOMER_TAB"
                      defaultChecked={
                        getNeededParams("CUSTOMER_TAB")?.defaultValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />
                    <label className="ml-05" htmlFor="CUSTOMER_TAB">
                      Customer Tab
                    </label>
                  </div>
                </Col>
                {/* {getNeededParams("CUSTOMER_TAB")?.selectedValue === true && (
                <Col span={24} className="mb-02 ml-18">
                  <div className="mb-1 merchantTextBox">
                    <label
                      className="text--grey fw-600"
                      htmlFor="customerTabName"
                    >
                      Customer Tab Name
                    </label>
                    <br />
                    <input
                      type="text"
                      name="CUSTOMER_TAB_NAME"
                      defaultValue={
                        getNeededParams("CUSTOMER_TAB")?.CUSTOMER_TAB_NAME
                      }
                      className="form-control"
                      id="customerTabName"
                      onChange={(e) =>
                        handleCustomerTabNameInput(e.target.value)
                      }
                    />
                  </div>
                </Col>
              )} */}
              </Row>

            )}
            {/* EOD REPORT */}
            {countryId != 18 && (
              <Row gutter={8} className="mb-02">
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name="EOD_REPORT"
                      value="EOD_REPORT"
                      id="EOD_REPORT"
                      defaultChecked={
                        getNeededParams("EOD_REPORT")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />
                    <label className="ml-05" htmlFor="EOD_REPORT">
                      EOD Report
                    </label>
                  </div>
                </Col>
              </Row>
            )}

            {countryId != 18 && (
              <Row gutter={8} className="mb-02">
                {getNeededParams("CREDIT_LIMIT") && (
                  <Col span={12}>
                    <div className="d-flex mb-02 alignCenter">
                      <input
                        type="checkbox"
                        name="CREDIT_LIMIT"
                        value="CREDIT_LIMIT"
                        id="CREDIT_LIMIT"
                        defaultChecked={getNeededParams("CREDIT_LIMIT")?.selectedValue}
                        onClick={(e) => handleCheckBox(e.target.name, e.target.checked)}
                      />
                      <label className="ml-05" htmlFor="CREDIT_LIMIT">
                        Credit Limit
                      </label>
                    </div>
                  </Col>
                )}
              </Row>
            )}



            {/* BOTTLE_DEPOSIT_FEE */}
            {countryId != 18 && (
              <Row gutter={8} className="mb-02">
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name="BOTTLE_DEPOSIT_FEE"
                      value="BOTTLE_DEPOSIT_FEE"
                      id="BOTTLE_DEPOSIT_FEE"
                      defaultChecked={
                        getNeededParams("BOTTLE_DEPOSIT_FEE")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />
                    <label className="ml-05" htmlFor="BOTTLE_DEPOSIT_FEE">
                      Bottle Deposit Fee ({currency}
                      {getNeededParams("BOTTLE_DEPOSIT_FEE")?.amount})
                    </label>
                  </div>
                </Col>
              </Row>
            )}


            {/* APPLY_FEE */}
            {countryId != 18 && (
              <Row gutter={8} className="mb-02">
                <Col span={12}>
                  <div className="d-flex mb-02 alignCenter">
                    <input
                      type="checkbox"
                      name="APPLY_FEE"
                      value="APPLY_FEE"
                      id="APPLY_FEE"
                      defaultChecked={
                        getNeededParams("APPLY_FEE")?.selectedValue
                      }
                      onClick={(e) =>
                        handleCheckBox(e.target.name, e.target.checked)
                      }
                    />
                    <label className="ml-05" htmlFor="APPLY_FEE">
                      Apply Fee ({currency}
                      {getNeededParams("APPLY_FEE")?.amount})
                    </label>
                  </div>
                </Col>
              </Row>
            )}


            <div className="text-right mb-1">
              <Button
                type="warning"
                htmlType="submit"
                className="btn--large"
                onClick={() => handleSubmit()}
              >
                {loader ? <SupportLoader /> : "Submit"}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Parameters;
